<div class="bg_clr">
  <div class="login_box">
    <div class="login_box_content">
      <div class="login-wrapper-bg">
        <div class="logo text-center">
          <div class="logo-img">
            <img src="../../../assets/images/login-logo.svg" class="img-responsive" alt="WOW" />
            <p>Ways of Working</p>
          </div>
        </div>
        <div class="login_content">
          <div class="login_form">
            <form action="" (submit)="savePassword()" novalidate='' #changePwd="ngForm" autocomplete="off">
              <div class="form-group">
                <mat-form-field class="example-full-width login-input">
                  <input matInput [type]="showPassword ? 'text' : 'password'" name="password" placeholder="Enter New Password"
                    [(ngModel)]="user.password" #password="ngModel" [pattern]="passwordRegExp" autocomplete="off" minlength="8" maxlength="20" required />
                  <img matSuffix *ngIf="showPassword" src="assets/images/show-pwd.svg" (click)="toggleInputType()">
                  <img matSuffix *ngIf="!showPassword" src="assets/images/hide-pwd@3x.png" (click)="toggleInputType()">
                  <mat-error *ngIf="password.errors && (password.dirty || password.touched)">
                    <mat-hint [hidden]="!password.errors.required">Password is required</mat-hint>
                    <mat-hint [hidden]="!password.errors.pattern">Must be 8 characters - 1
                      uppercase, 1 lowercase, 1 digit and 1 special character
                    </mat-hint>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-actions">
                <button class="save" [disabled]="changePwd.invalid">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>